var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('BaseImg',{attrs:{"option":{
    style: {
      margin: '12px 0 0 16px',
      alignSelf: 'flex-start',
      width: '89px',
    },
    url: 'logo.png',
  }}}),_c('div',{staticClass:"key-box"},[_c('div',{staticClass:"r-body"},[_vm._v(" 活动期间成交的客户，除了享受现场签约好礼外（5月8日14:00）还可参与线上抽奖 "),_c('span',{staticClass:"tips1"},[_vm._v("戴森净化器，华为65寸超薄电视 米家扫地机器人等大奖")]),_c('span',{staticClass:"tips2"},[_vm._v("更有罗莱家纺四件套、张小泉刀具套装、九阳空气炸锅等惊喜好礼！")]),_c('span',{staticClass:"tips3"},[_vm._v("活动时间：4月15日-5月8日")]),_c('div',{staticClass:"btn",on:{"click":_vm.submit}},[_vm._v("密钥兑换")])])]),_c('BasePaySuccessSecret'),_c('BaseBtnHome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }